import script from "./RestartAccountPasswordResetComplete.vue?vue&type=script&lang=ts&setup=true"
export * from "./RestartAccountPasswordResetComplete.vue?vue&type=script&lang=ts&setup=true"

import "./RestartAccountPasswordResetComplete.vue?vue&type=style&index=0&id=afbff98e&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-afbff98e"]])

export default __exports__